module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page browser-page"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Update Your Browser")]), _vm._v(" "), _c('p', [_vm._v("\n    We only support the latest browsers, and there’s plently to choose from.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "chrome",
    attrs: {
      "href": "https://www.google.com/chrome/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "firefox",
    attrs: {
      "href": "https://www.mozilla.org/en-US/firefox/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "brave",
    attrs: {
      "href": "https://brave.com/download/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "opera",
    attrs: {
      "href": "https://www.opera.com/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "yandex",
    attrs: {
      "href": "https://browser.yandex.com/"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc3b0a3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/browser.vue
// module id = 1636
// module chunks = 180